import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssetqrapprovalRoutingModule } from './assetqrapproval-routing.module';
import { AssetQrApprovalLinkComponent } from './asset-qr-approval-link/asset-qr-approval-link.component';
import { AssetQrApprovalLandingComponent } from './asset-qr-approval-landing/asset-qr-approval-landing.component';
import { AssetQrApprovalDetailComponent } from './asset-qr-approval-detail/asset-qr-approval-detail.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { ApprovalDialogComponent } from './approval-dialog/approval-dialog.component';


@NgModule({
  declarations: [
    AssetQrApprovalLinkComponent,
    AssetQrApprovalLandingComponent,
    AssetQrApprovalDetailComponent,
    ApprovalDialogComponent
  ],
  imports: [
    CommonModule,
    AssetqrapprovalRoutingModule,
    AcademicFormModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule
  ]
})
export class AssetqrapprovalModule { }
